import React from "react";
import { IMultipleUsersHelpers } from "repoV2/features/Common/modules/FormData/interfaces/MultipleUserHelpers.interfaces";
import styles from "./AddNewUsers.module.scss";
import AddNewUsersButton from "../../../../../AddNewUsersButton/AddNewUsersButton";
import AddMultipleUserCount from "../AddMultipleUserCount/AddMultipleUserCount";

const AddNewUsers = (props: {
    enableMultipleUserCountFlow: boolean;
    handleAddNewUser: () => void;
    allUserIds: IMultipleUsersHelpers["allUserIds"];
}) => {
    const { enableMultipleUserCountFlow, handleAddNewUser, allUserIds } = props;

    return (
        <div>
            {enableMultipleUserCountFlow ? (
                <div className={styles.multipleUsersCountContainer}>
                    <AddMultipleUserCount allUserIds={allUserIds} />
                </div>
            ) : (
                <div className={styles.multipleUsersContainer}>
                    <AddNewUsersButton
                        handleUserDetailsFormOpen={handleAddNewUser}
                        allUserIds={allUserIds}
                    />
                </div>
            )}
        </div>
    );
};

export default AddNewUsers;
